<template>
  <div class="overview-v2">
    <el-descriptions
      :column="2"
      border
      size="samll"
      class="overview-desc"
      :contentStyle="{ width: '40%', padding: '4px 10px' }"
      :labelStyle="{ width: '160px' }"
    >
      <el-descriptions-item label="账号状态">
        <div class="desc-row">
          <div class="desc-left">
            <el-tag :type="statusText === '正常' ? 'success' : 'danger'">{{ statusText }}</el-tag>
            <span v-if="statusRemarkText" class="muted"> (状态备注 {{ statusRemarkText }})</span>
          </div>
          <div class="desc-right">
            <MemberInfo compact :member-info="memberMinInfo" @status-change="handleStatusChanged" />

            <!-- <el-button type="text" size="mini" @click="openBlacklist('uid', uid)">拉黑账号</el-button> -->
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="账户余额">
        <div class="desc-row">
          <div class="desc-left">
            <span>{{ formatYuan(baseInfo.gold) }}</span
            ><span class="muted"> 剩余打码量 {{ formatYuan(baseInfo.lock_gold) }}</span>
          </div>
          <div class="desc-right">
            <el-button type="text" size="small" @click="openAccountChange">帐变记录</el-button>
            <el-button type="text" size="small" @click="openManualAdjust('up')">手动加款</el-button>
            <el-button type="text" size="small" @click="openManualAdjust('down')">手动扣除</el-button>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="上级代理">
        <div class="desc-row">
          <div class="desc-left">{{ agentText }}</div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="代理佣金">
        <div class="desc-row">
          <div class="desc-left">
            {{ commissionText }}&nbsp;
            <span>
              直属代理 (<span v-if="!baseInfo.share_one_num">{{ baseInfo.share_one_num }}</span>
              <el-button v-else type="text" size="small" @click="handleAgentInviteUserList('direct')">{{
                baseInfo.share_one_num
              }}</el-button
              >)</span
            >&nbsp;
            <span>
              二级代理 (<span v-if="!baseInfo.share_two_num">{{ baseInfo.share_two_num }}</span>
              <el-button v-else type="text" size="small" @click="handleAgentInviteUserList('indirect')">{{
                baseInfo.share_two_num
              }}</el-button
              >)</span
            >
          </div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="累计充值">
        <div class="desc-row">
          <div class="desc-left">
            {{ formatYuan(baseInfo.total_payin_amount) }}({{
              baseInfo.total_payin_times != null ? baseInfo.total_payin_times : 0
            }}次) 今日充值 {{ formatYuan(baseInfo.today_payin_amount) }} &nbsp;历史最大单笔充值
            {{ formatYuan(baseInfo.payin_amount_max) }}
          </div>
          <div class="desc-right">
            <el-button type="text" size="small" @click="openPayinHistory">充值记录</el-button>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="累计提现">
        <div class="desc-row">
          <div class="desc-left">
            {{ formatYuan(baseInfo.total_payout_amount) }}({{
              baseInfo.total_payout_times != null ? baseInfo.total_payout_times : 0
            }}次) 今日提现 {{ formatYuan(baseInfo.today_payout_amount) }} &nbsp;历史最大单笔提现
            {{ formatYuan(baseInfo.payout_amount_max) }}
          </div>
          <div class="desc-right">
            <el-button type="text" size="small" @click="openPayoutHistory">提现记录</el-button>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="充值差额">
        <div class="desc-row">
          <div class="desc-left">{{ formatYuan(baseInfo.payment_win_loss ?? baseInfo.total_payment_win_loss) }}</div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="资金修正(人工)">
        <div class="desc-row">
          <div class="desc-left">
            累计加款 {{ formatYuan(baseInfo.admin_add_gold) }} &nbsp;累计扣除{{ formatYuan(baseInfo.admin_sub_gold) }}
          </div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="今日投注">
        <div class="desc-row">
          <div class="desc-left">
            {{ formatYuan(baseInfo.today_bet_amount) }} 总投注 {{ formatYuan(baseInfo.total_bet_amount) }}
          </div>
          <div class="desc-right">
            <el-button type="text" size="small" @click="openBetHistory">投注统计</el-button>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="今日输赢">
        <div class="desc-row">
          <div class="desc-left">
            输赢金额({{ formatYuan(baseInfo.today_win_loss_amount) }}) 总输赢金额{{
              formatYuan(baseInfo.total_win_loss_amount)
            }}
            (杀分率 {{ winRateText }})
          </div>
          <div class="desc-right">
            <el-button type="text" size="small" @click="handleSetRtp">设置玩家RTP</el-button>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="活动优惠">
        <div class="desc-row">
          <div class="desc-left">
            活动奖励 {{ formatYuan(baseInfo.activity_reward) }} 任务奖励 {{ formatYuan(baseInfo.task_reward) }} 累计返水
            {{ formatYuan(baseInfo.bet_rebate_gold) }} 充值优惠 {{ formatYuan(baseInfo.payin_bonus) }} 放弃奖励
            {{ formatYuan(baseInfo.give_up_reward) }}
          </div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="VIP等级">
        <div class="desc-row">
          <div class="desc-left">
            VIP{{ baseInfo.vip_level != null ? baseInfo.vip_level : 0 }}
            <span class="muted">(已领取 {{ formatYuan(baseInfo.vip_reward) }})</span>
            <span v-if="baseInfo.next_vip_level != null" class="muted">
              距离VIP{{ baseInfo.next_vip_level }} 充值还差 {{ formatYuan(baseInfo.next_vip_need_exp) }} 下注还差
              {{ formatYuan(baseInfo.next_vip_need_lock_bet_amount) }}
            </span>
          </div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="会员标签">
        <div class="desc-row">
          <div class="desc-left">--</div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="登录密码">
        <div class="desc-row">
          <div class="desc-left">
            ****
            <span v-if="baseInfo.same_login_password_num != null" class="muted"
              >同登录密码人数({{ baseInfo.same_login_password_num }})</span
            >
          </div>
          <div class="desc-right">
            <el-button type="text" size="small" @click="openModifyLoginPassword">修改登录密码</el-button>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="提现密码">
        <div class="desc-row">
          <div class="desc-left">
            ****
            <span v-if="baseInfo.same_payout_password_num != null" class="muted"
              >同提现密码人数({{ baseInfo.same_payout_password_num }})</span
            >
          </div>
          <div class="desc-right">
            <el-button type="text" size="small" @click="handleResetWithdrawPassword">重置提现密码</el-button>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="提现账号">
        <div class="desc-row">
          <div class="desc-left">{{ baseInfo.payout_card_num || '0' }}个</div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="注册IP">
        <div class="desc-row">
          <div class="desc-left">
            <el-button
              v-if="baseInfo.register_ip"
              type="text"
              size="small"
              @click="openIpDetail(baseInfo.register_ip)"
              >{{ baseInfo.register_ip }}</el-button
            >
            <span v-else>--</span>
            <span> 注册时间 {{ formatTs(baseInfo.register_at) }}</span>
            <span v-if="baseInfo.register_days != null" class="muted"> (已注册{{ baseInfo.register_days }}天)</span>
            <span v-if="baseInfo.same_register_ip_num != null" class="muted">
              同IP人数({{ baseInfo.same_register_ip_num }})</span
            >
          </div>
          <div class="desc-right">
            <el-button
              v-if="baseInfo?.black_register_ip === 0"
              type="text"
              size="small"
              @click="openBlacklist('ip', baseInfo.register_ip)"
            >
              拉黑IP
            </el-button>
            <el-popover
              v-if="baseInfo?.black_register_ip == 1"
              title=""
              placement="top"
              trigger="hover"
              :content="baseInfo?.black_register_ip_desc"
            >
              <el-tag style="cursor: pointer" slot="reference" type="danger" size="mini">{{
                getBlackStatusText(baseInfo?.black_register_ip)
              }}</el-tag>
            </el-popover>
            <el-popconfirm
              v-if="baseInfo?.black_register_ip == 1"
              title="确认移除该条黑名单？"
              @confirm="removeBlacklist('ip', baseInfo.register_ip)"
            >
              <template #reference>
                <el-button type="text" size="small">移除</el-button>
              </template>
            </el-popconfirm>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="注册域名">
        <div class="desc-row">
          <div class="desc-left">{{ baseInfo.init_host || baseInfo.register_host || '--' }}</div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="注册设备号">
        <div class="desc-row">
          <div class="desc-left">
            <span v-if="baseInfo.register_device">
              <el-button type="text" size="small" @click="openDeviceDetail(baseInfo.register_device)">{{
                baseInfo.register_device || '--'
              }}</el-button
              >(设备号)
            </span>
            <span v-else>--</span>
            <span v-if="baseInfo.same_register_device_num != null" class="muted">
              同注册设备人数({{ baseInfo.same_register_device_num }})</span
            >
          </div>
          <div class="desc-right">
            <el-button
              type="text"
              size="small"
              v-if="baseInfo?.black_register_device === 0"
              @click="openBlacklist('device_id', baseInfo.register_device)"
            >
              拉黑设备
            </el-button>

            <el-popover
              v-if="baseInfo?.black_register_device == 1"
              title=""
              placement="top"
              trigger="hover"
              :content="baseInfo?.black_register_device_desc"
            >
              <el-tag style="cursor: pointer" slot="reference" type="danger" size="mini">{{
                getBlackStatusText(baseInfo?.black_register_device)
              }}</el-tag>
            </el-popover>
            <el-popconfirm
              v-if="baseInfo?.black_register_device == 1"
              title="确认移除该条黑名单？"
              @confirm="removeBlacklist('device_id', baseInfo.register_device)"
            >
              <template #reference>
                <el-button type="text" size="small">移除</el-button>
              </template>
            </el-popconfirm>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="注册浏览器指纹">
        <div class="desc-row">
          <div class="desc-left">{{ baseInfo.register_user_agent || '--' }}</div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="注册来源">
        <div class="desc-row">
          <div class="desc-left">{{ registerTypeText }}</div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="最后登录IP">
        <div class="desc-row">
          <div class="desc-left">
            <el-button v-if="baseInfo.login_ip" type="text" size="small" @click="openIpDetail(baseInfo.login_ip)">{{
              baseInfo.login_ip
            }}</el-button>
            <span v-else>--</span>

            <span v-if="baseInfo.same_login_ip_num != null" class="muted">
              同IP人数({{ baseInfo.same_login_ip_num }})</span
            >
            <span> 登录时间 {{ formatTs(baseInfo.LoginAt) }}</span>
          </div>
          <div class="desc-right">
            <el-button
              type="text"
              size="small"
              v-if="baseInfo?.black_login_ip === 0"
              @click="openBlacklist('ip', baseInfo.login_ip)"
            >
              拉黑IP
            </el-button>
            <el-popover
              v-if="baseInfo?.black_login_ip == 1"
              title=""
              placement="top"
              trigger="hover"
              :content="baseInfo?.black_login_ip_desc"
            >
              <el-tag style="cursor: pointer" slot="reference" type="danger" size="mini">{{
                getBlackStatusText(baseInfo?.black_login_ip)
              }}</el-tag>
            </el-popover>
            <el-popconfirm
              v-if="baseInfo?.black_login_ip == 1"
              title="确认移除该条黑名单？"
              @confirm="removeBlacklist('ip', baseInfo.login_ip)"
            >
              <template #reference>
                <el-button type="text" size="small">移除</el-button>
              </template>
            </el-popconfirm>
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="最后登录域名">
        <div class="desc-row">
          <div class="desc-left">{{ baseInfo.login_host || '--' }}</div>
          <div class="desc-right"></div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="最后登录设备号">
        <div class="desc-row">
          <div class="desc-left">
            <span v-if="baseInfo.login_device">
              <el-button type="text" size="small" @click="openDeviceDetail(baseInfo.login_device)">{{
                baseInfo.login_device
              }}</el-button>
              (设备号)
            </span>
            <span v-else>--</span>
            <span v-if="baseInfo.same_login_device_num != null" class="muted">
              同登录设备人数({{ baseInfo.same_login_device_num }})</span
            >
          </div>
          <div class="desc-right">
            <el-button
              type="text"
              size="small"
              v-if="baseInfo?.black_login_device === 0"
              @click="openBlacklist('device_id', baseInfo.login_device)"
            >
              拉黑设备
            </el-button>
            <el-popover
              v-if="baseInfo?.black_login_device == 1"
              title=""
              placement="top"
              trigger="hover"
              :content="baseInfo?.black_login_device_desc"
            >
              <el-tag style="cursor: pointer" slot="reference" type="danger" size="mini">{{
                getBlackStatusText(baseInfo?.black_login_device)
              }}</el-tag>
            </el-popover>
            <el-popconfirm
              v-if="baseInfo?.black_login_device == 1"
              title="确认移除该条黑名单？"
              @confirm="removeBlacklist('device_id', baseInfo.login_device)"
            >
              <template #reference>
                <el-button type="text" size="small">移除</el-button>
              </template>
            </el-popconfirm>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>

    <AccountChangeDialogV2 :visible.sync="dialogs.accountChange" :uid="uid" :target-info="targetInfo" />
    <ManualAdjustDialogV2
      :visible.sync="dialogs.manualAdjust"
      :uid="uid"
      :target-info="targetInfo"
      :member-info="memberInfoForAdjust"
      :mode="manualAdjustMode"
      @success="handleAdjustSuccess"
    />
    <PayinHistoryDialogV2 :visible.sync="dialogs.payinHistory" :uid="uid" :target-info="targetInfo" />
    <PayoutHistoryDialogV2 :visible.sync="dialogs.payoutHistory" :uid="uid" :target-info="targetInfo" />
    <BetHistoryDialogV2 :visible.sync="dialogs.betHistory" :uid="uid" :target-info="targetInfo" />

    <ModifyLoginPasswordDialog :visible.sync="dialogs.modifyLoginPassword" :user-info="modifyLoginUser" />
    <SetRtpDialogV2
      :visible.sync="dialogs.setRtp"
      :uid="uid"
      :target-info="targetInfo"
      :initial-rtp="baseInfo.rtp"
      @success="handleSetRtpSuccess"
    />
    <!-- 设备详情弹窗 -->
    <ManageDeviceDetailDialog :visible.sync="dialogs.deviceDetail" :device-no="selectedDeviceNo" />
    <!-- IP详情弹窗 -->
    <ManageIpDetailDialog :visible.sync="dialogs.ipDetail" :ip="selectedIp" />
    <AgentInviteUserListDialog
      :visible.sync="dialogs.agentInviteUserList"
      :type="agentInviteUserListType"
      :inviter-uid="uid"
      :username="userInfo.username"
    />

    <CreateBlackDialog
      :visible.sync="blackDialogVisible"
      :row="blackEditingRow"
      :type-options="blackTypeOptions"
      :method-options="blackMethodOptions"
      :lock-type-value="true"
      :account-prefill="blackAccountPrefill"
      @saved="handleBlacklistSaved"
    />
  </div>
</template>

<script>
import { computed, getCurrentInstance, ref, watch, reactive, inject } from 'vue'
import { centsToYuan } from '@/utils/amount'
import { formatTimestamp } from '@/utils/time'
import { MemberApi } from '@/api/member/member'
import MemberInfo from './member-info.vue'
import ModifyLoginPasswordDialog from './modify-login-password.vue'
import AccountChangeDialogV2 from './v2/AccountChangeDialogV2.vue'
import ManualAdjustDialogV2 from './v2/ManualAdjustDialogV2.vue'
import PayinHistoryDialogV2 from './v2/PayinHistoryDialogV2.vue'
import PayoutHistoryDialogV2 from './v2/PayoutHistoryDialogV2.vue'
import BetHistoryDialogV2 from './v2/BetHistoryDialogV2.vue'
import SetRtpDialogV2 from './v2/SetRtpDialogV2.vue'
import AgentInviteUserListDialog from '@/pages/admin/agent/components/agent-invite-user-list.dialog.vue'
import CreateBlackDialog from '@/pages/admin/riskControl/manageList/components/CreateBlackDialog.vue'
import { loginLogApi } from '@/api/riskControl/loginLog'

const blackMap = {
  1: '已拉黑',
  0: '正常',
}
// 1 普通注册，2 后台注册，3 分享注册
const registerTypeMap = {
  1: '投放渠道',
  2: '邀请注册',
  3: '普通注册',
}

const blackTypeOptions = [
  { label: 'IP', value: 2 },
  { label: '设备号', value: 3 },
  { label: '会员ID', value: 4 },
]
const blackMethodOptions = [
  { label: '限制注册', value: 1 },
  { label: '限制登录', value: 2 },
  { label: '限制提现', value: 3 },
]
export default {
  name: 'ManageOverviewTabV2',
  components: {
    MemberInfo,
    ModifyLoginPasswordDialog,
    AccountChangeDialogV2,
    ManualAdjustDialogV2,
    PayinHistoryDialogV2,
    PayoutHistoryDialogV2,
    BetHistoryDialogV2,
    SetRtpDialogV2,
    // 异步加载以打断与 MemberAccountCell 的循环依赖
    ManageDeviceDetailDialog: () =>
      import('@/pages/admin/riskControl/loginLog/components/ManageDeviceDetailDialog.vue'),
    ManageIpDetailDialog: () => import('@/pages/admin/riskControl/loginLog/components/ManageIpDetailDialog.vue'),
    AgentInviteUserListDialog,
    CreateBlackDialog,
  },
  props: {
    uid: {
      type: Number,
      default: 0,
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    const loading = ref(false)
    const baseInfo = ref({})
    const blackDialogVisible = ref(false)
    const blackEditingRow = ref(null)
    /** 仅「拉黑账号」时传入，用于弹窗标题并隐藏类型/值 */
    const blackAccountPrefill = ref(null)
    const dialogs = reactive({
      accountChange: false,
      manualAdjust: false,
      payinHistory: false,
      payoutHistory: false,
      betHistory: false,
      modifyLoginPassword: false,
      setRtp: false,
      deviceDetail: false,
      ipDetail: false,
      agentInviteUserList: false,
    })

    const manualAdjustMode = ref('up') // up|down

    const rows = computed(() => [
      { key: 'status', label: '账号状态' },
      { key: 'agent', label: '上级代理' },
      { key: 'commission', label: '代理佣金' },
      { key: 'balance', label: '账户余额' },
      { key: 'adjustStat', label: '资金修正(人工)' },
      { key: 'payinTotal', label: '累计充值' },
      { key: 'payoutTotal', label: '累计提现' },
      { key: 'payinDiff', label: '充提差额' },
      { key: 'todayBet', label: '今日投注' },
      { key: 'todayWinLoss', label: '今日输赢' },
      { key: 'activityReward', label: '活动优惠' },
      { key: 'vip', label: 'VIP等级' },
      { key: 'tags', label: '会员标签' },
      { key: 'loginPwd', label: '登录密码' },
      { key: 'payoutPwd', label: '提现密码' },
      { key: 'payoutAccount', label: '提现账号' },
      { key: 'registerIp', label: '注册IP' },
      { key: 'registerHost', label: '注册域名' },
      { key: 'registerDevice', label: '注册设备号' },
      { key: 'registerUa', label: '注册浏览器指纹' },
      { key: 'registerSource', label: '注册来源' },
      { key: 'lastLoginIp', label: '最后登录IP' },
      { key: 'lastLoginHost', label: '最后登录域名' },
      { key: 'lastLoginDevice', label: '最后登录设备号' },
    ])

    const targetInfo = computed(() => props.userInfo || {})

    const memberMinInfo = computed(() => ({
      uid: props.uid,
      username: props.userInfo?.username,
      status: Number(baseInfo.value.status),
    }))

    const memberInfoForAdjust = computed(() => ({
      gold: baseInfo.value.gold,
      account_info: { gold: baseInfo.value.gold },
    }))

    const modifyLoginUser = computed(() => ({
      account: props.userInfo?.username || '',
      uid: props.uid,
    }))

    const formatYuan = cents => {
      if (cents == null || cents === '') return '--'
      return centsToYuan(cents)
    }

    const formatTs = ts => {
      if (ts == null || ts === '' || ts === 0) return '--'
      return formatTimestamp(ts)
    }
    const registerTypeText = computed(() => {
      const v = registerTypeMap[baseInfo.value.register_type]
      if (v == undefined || v === '' || v == null) return '--'
      return baseInfo.value.register_type === 1 ? v + ' ' + baseInfo.value.ads_channel + '' : v
    })

    const statusText = computed(() => (Number(baseInfo.value.status) === 1 ? '正常' : '停用'))
    const statusRemarkText = computed(() => baseInfo.value.status_desc || '')

    const agentText = computed(() => {
      const v = baseInfo.value.inviter_uid
      return v != null && v !== 0 ? String(v) : '--'
    })

    const commissionText = computed(() => {
      const commission = baseInfo.value.agent_back_gold
      if (commission == null || commission === '') return '累计佣金 —'
      return `累计佣金 ${centsToYuan(commission)}`
    })

    const winRateText = computed(() => {
      const w = baseInfo.value.win_rate
      if (w == null || w === '') return '--'
      const n = Number(w)
      if (Number.isNaN(n)) return String(w)
      return n.toFixed(2) + '%'
    })
    const statusChange = ref(false)
    const MEMBER_INFO_PROVIDER = inject('MEMBER_INFO_PROVIDER', '')
    const handleStatusChanged = () => {
      loadBaseInfo(props.uid)
      emit('status-changed')
      console.log('MEMBER_INFO_PROVIDER', MEMBER_INFO_PROVIDER)
      if (MEMBER_INFO_PROVIDER) {
        MEMBER_INFO_PROVIDER.changeStatus = true
        statusChange.value = true
      }
    }

    const openAccountChange = () => (dialogs.accountChange = true)
    const openManualAdjust = mode => {
      manualAdjustMode.value = mode
      dialogs.manualAdjust = true
    }
    const openPayinHistory = () => (dialogs.payinHistory = true)
    const openPayoutHistory = () => (dialogs.payoutHistory = true)
    const openBetHistory = () => {
      emit('open-bet-history')
    }
    const openModifyLoginPassword = () => (dialogs.modifyLoginPassword = true)

    const handleResetWithdrawPassword = () => {
      proxy
        ?.$confirm?.('是否确定清除当前用户的取款密码，清除后用户可进行再次设置。', '重置提现密码', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(async () => {
          const res = await MemberApi.resetPayPassword({ uid: props.uid })
          if (res.code === 0) proxy?.$message?.success('重置成功')
          else proxy?.$message?.error(res.msg || '重置失败')
        })
    }

    const handleSetRtp = () => {
      if (!props.uid) return proxy?.$message?.error('缺少会员ID')
      dialogs.setRtp = true
    }

    const handleAdjustSuccess = () => {
      loadBaseInfo(props.uid)
      emit('status-changed')
    }

    const handleSetRtpSuccess = () => {
      proxy?.$message?.success('设置RTP成功')
      emit('status-changed')
    }

    const openDeviceDetail = deviceNo => {
      selectedDeviceNo.value = deviceNo

      dialogs.deviceDetail = true
    }
    const selectedDeviceNo = ref('')
    const selectedIp = ref('')
    const openIpDetail = ip => {
      selectedIp.value = ip
      dialogs.ipDetail = true
    }
    const agentInviteUserListType = ref('direct')
    const handleAgentInviteUserList = type => {
      dialogs.agentInviteUserList = true
      agentInviteUserListType.value = type
    }
    const loadBaseInfo = async uid => {
      if (!uid) return
      loading.value = true
      try {
        const res = await MemberApi.getBaseInfoV2(uid)
        baseInfo.value = res?.data || {}
      } catch (e) {
        baseInfo.value = {}
        proxy?.$message?.error('获取会员详情失败')
      } finally {
        loading.value = false
      }
    }

    watch(
      () => props.uid,
      uid => {
        if (uid) loadBaseInfo(uid)
      },
      { immediate: true }
    )

    const resolveBlackTypeValue = type => {
      if (type === 'ip') return 2
      if (type === 'device_id') return 3
      if (type === 'uid') return 4
      return 0
    }
    const openBlacklist = (type, value) => {
      const v = value != null ? String(value) : ''
      if (!v) return proxy?.$message?.warning?.('缺少可拉黑的值')
      const t = resolveBlackTypeValue(type)
      if (!t) return proxy?.$message?.warning?.('不支持的拉黑类型')
      blackAccountPrefill.value = type === 'uid' ? { username: props.userInfo?.username || '', uid: props.uid } : null
      blackEditingRow.value = {
        block_type: t,
        block_value: v,
        limit_type: [],
        reason: '',
      }
      blackDialogVisible.value = true
    }
    const handleBlacklistSaved = () => loadBaseInfo(props.uid)

    const getBlackStatusText = status => {
      return blackMap?.[status] || ''
    }

    /** 与风控名单 List.vue buildParams 一致，用于按类型+值查列表取 id */
    const buildBlacklistQueryParams = (type, rawValue) => {
      const bv = rawValue != null ? String(rawValue).trim() : ''
      const bt = resolveBlackTypeValue(type)
      if (!bv || !bt) return null
      const params = { block_type: bt, page: 1, page_size: 100 }
      if (bt === 2) params.ip = bv
      else if (bt === 3) params.device_id = bv
      else if (bt === 4) params.uid = bv
      return { params, expectValue: bv, blockType: bt }
    }

    const removeBlacklist = async (type, value) => {
      const built = buildBlacklistQueryParams(type, value)
      if (!built) {
        proxy?.$message?.warning?.('缺少可移除的黑名单条件')
        return
      }
      const { params, expectValue, blockType } = built
      try {
        const res = await loginLogApi.getBlacklistList(params)
        if (res?.code !== 0) {
          proxy?.$message?.error(res?.msg || '查询黑名单失败')
          return
        }
        const list = res?.data?.list || []
        const ids = list
          .filter(r => Number(r.block_type) === blockType && String(r.block_value ?? '').trim() === expectValue)
          .map(r => r?.id ?? r?.black_id)
          .filter(id => id != null)
        if (!ids.length) {
          proxy?.$message?.warning?.('未找到对应黑名单记录，请刷新后重试或到风控名单核对')
          return
        }
        await loginLogApi.deleteBlacklist({ ids, del_type: 1 })
        proxy?.$message?.success?.('移除成功')
        await loadBaseInfo(props.uid)
      } catch (e) {
        proxy?.$message?.error(e?.message || '移除失败')
      }
    }
    return {
      loading,
      baseInfo,
      blackDialogVisible,
      blackEditingRow,
      blackAccountPrefill,
      blackTypeOptions,
      blackMethodOptions,
      selectedDeviceNo,
      selectedIp,
      dialogs,
      rows,
      targetInfo,
      memberMinInfo,
      memberInfoForAdjust,
      modifyLoginUser,
      manualAdjustMode,
      formatYuan,
      formatTs,
      statusText,
      statusRemarkText,
      agentText,
      commissionText,
      winRateText,
      registerTypeText,
      agentInviteUserListType,
      handleStatusChanged,
      openAccountChange,
      openManualAdjust,
      openPayinHistory,
      openPayoutHistory,
      openBetHistory,
      openModifyLoginPassword,
      handleResetWithdrawPassword,
      handleSetRtp,
      handleSetRtpSuccess,
      handleAdjustSuccess,
      openDeviceDetail,
      openIpDetail,
      handleAgentInviteUserList,
      openBlacklist,
      handleBlacklistSaved,
      getBlackStatusText,
      removeBlacklist,
    }
  },
}
</script>

<style lang="scss" scoped>
.overview-v2 {
  padding: 6px 0 0;
}

.overview-desc {
  width: 100%;
}

.cell-value {
  font-size: 12px;
  line-height: 20px;
  color: #303133;
}
.muted {
  color: #909399;
}
.desc-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 20px;
}
.desc-left {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 20px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
}
.desc-right {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}
.desc-right ::v-deep .history-btn {
  margin-left: 6px;
}
</style>
